import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default function BetDetails_ShowCombinations(props: {
	setShowCombinations: (v: boolean) => void;
}) {
	const { t } = useTranslation("mybets");
	const myBetsStore = useContext(MyBetsStoreContext);
	const bet = useContext(MyBetsBetContext);

	return (
		<>
			<td className="table--bets__dd">
				<div>
					{t("ITEM.ADDITIONAL_NUM_BETS")}
					{bet.totalNumberOfCombinations > 1 && (
						<span
							className="u-mar--left--xtny no-print"
							onClick={() => {
								props.setShowCombinations(true);
								myBetsStore?.initBetCombinationForBetSlip(bet);
							}}
						>
							(
							<span className="u-anchor u-anchor--secondary u-anchor--underline u-type--wgt--medium">
								{t<string>("ITEM.SHOW_COMBINATIONS")}
							</span>
							)
						</span>
					)}
				</div>
			</td>
			<td className="table--bets__dd">{bet.totalNumberOfCombinations}</td>
		</>
	);
}
